<script>
    export let activity
</script>

<div class="field">
    <label for="ref">Referência</label>
    <textarea name="ref" rows="4" bind:value={activity.basis.variant.reference}></textarea>
</div>
